import { useCallback } from "react";
import type { Dispatch, KeyboardEvent, SetStateAction } from "react";

type Params = {
  isDisabled?: boolean;
  isOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  selectAt: (index: number) => void;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  activeIndex: number;
  optionsLength: number;
};

export function useSupportSelectKeyboard({
  isDisabled,
  isOpen,
  openMenu,
  closeMenu,
  selectAt,
  setActiveIndex,
  setIsOpen,
  activeIndex,
  optionsLength,
}: Params) {
  return useCallback(
    (event: KeyboardEvent<HTMLButtonElement>) => {
      if (isDisabled) return;
      if (!isOpen) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          openMenu();
        }
        return;
      }
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          event.stopPropagation();
          setActiveIndex((prev) => (prev + 1 >= optionsLength ? 0 : prev + 1));
          break;
        case "ArrowUp":
          event.preventDefault();
          event.stopPropagation();
          setActiveIndex((prev) => (prev <= 0 ? optionsLength - 1 : prev - 1));
          break;
        case "Home":
          event.preventDefault();
          event.stopPropagation();
          setActiveIndex(0);
          break;
        case "End":
          event.preventDefault();
          event.stopPropagation();
          setActiveIndex(optionsLength - 1);
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          event.stopPropagation();
          if (activeIndex >= 0) selectAt(activeIndex);
          break;
        case "Escape":
          event.preventDefault();
          event.stopPropagation();
          closeMenu();
          break;
        case "Tab":
          setIsOpen(false);
          break;
        default:
          break;
      }
    },
    [activeIndex, closeMenu, isDisabled, isOpen, openMenu, optionsLength, selectAt, setActiveIndex, setIsOpen],
  );
}
